import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { apiConfig, apiGetPage } from '../../request/api'
import { useCustomData } from '../../pages/context/indexCustomDataContext';
import '../../assets/css/home.css'

const HomePart1: React.FC = () => {
    const navigate = useNavigate();
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { getValue } = useCustomData();
    const firstContent = getValue('indexFirstIntroduceFirstContent');
    const secondContent = getValue('indexFirstIntroduceSecondContent');
    const thirdContent = getValue('indexFirstIntroduceThirdContent');
    const fourthContent = getValue('indexFirstIntroduceFourthContent');


    const firstCloumn = getValue('indexFirstIntroduceFirstTitle');
    const secCloumn = getValue('indexFirstIntroduceSecondTitle');
    const thirdCloumn = getValue('indexFirstIntroduceThirdTitle');
    const fourCloumn = getValue('indexFirstIntroduceFourthTitle');
    
    const mainTitle = getValue('indexFirstTitle');
    const subTitle = getValue('indexFirstSubTitle');
    const mainInfo = getValue('indexFirstContent');
    const knowMore = getValue('knowMore');
 
    return (
        <div className="home-part1" style={{ 'backgroundColor': themeColor }}>
            <div className='part1-header'>
                <div className='part1-header_left'>
                    <div>{mainTitle}</div>
                    <div>{subTitle}</div>
                </div>
                <div className='part1-header_middle'>
                    <div>{mainInfo}</div>
                </div>
                <div className='part1-header_right'>
                    <button onClick={() => navigate('/about', { state: { initialView: 'service-index' } })}>{knowMore}</button>
                </div>
            </div>
            <div className='part1-middle'>
                <div></div>
            </div>
            <div className='part1-bottom'>
                <div className='part1-bottom_item'>
                    <div>{firstCloumn}</div>
                     <div>{firstContent}</div>
                </div>
                <div className='part1-bottom_item'>
                    <div>{secCloumn}</div>
                     <div>{secondContent}</div>
                </div>
                <div className='part1-bottom_item'>
                    <div>{thirdCloumn}</div>
                     <div>{thirdContent}</div>
                </div>
                <div className='part1-bottom_item'>
                    <div>{fourCloumn}</div>
                     <div>{fourthContent}</div>
                </div>
            </div>
        </div>
    );
};

export default HomePart1;